export class Slot {
    uuid: string;
    session_day_time_uuid: string;
    slot_start_time: string = ""; // 09:00:00
    slot_end_time: string = ""; // 09:00:00
    status: string;
    sessions_timezone: string = "Asia/Karachi";
    slot_Date: string = ''; // 2025-02-11T00:00:00.000Z
    slot_Date_Utc: string = null; // 2025-02-11T09:00:00.000Z
    slot_Time: string = ""; // 09:00:00
    session_day_time: SessionDayTime;
    available:boolean = false;
}
export class availableSlot{
    slots: Slot[] = [];
    date:string
}
export class SessionDayTime {
    uuid: string= null;
    session_day_id: number = null;
    start_time: string = ""; //09:00:00";
    end_time: string = ""; //10:00:00
    status: string;
    sessionDay: SessionDay;
}
export class SessionDay {
    uuid: string;
    account_session_id: number;
    day_id: string = "";//1,2,3..., 7;
    status: string;
}
export class SlotUI {
    uuid: string = null;
    time: string = "" ;
    status :string = "Active" ;
    available:boolean = false;
    localUtcDate:Date = null;
    UtcDate: string = null;
    Utc_date_time:string = null;
    getUtcDateOnly(LocalUtcDate: string): string {
        const date = new Date(LocalUtcDate);

        // Set hours, minutes, seconds, and milliseconds to zero (UTC)
        date.setUTCHours(0, 0, 0, 0);
        return date.toISOString();
    }

    constructor(slot?:Slot){
        if(slot){
            const [hour, minute, second] = slot.slot_Time.split(':');
            const hours = (parseInt(hour) % 12 || 12).toString().padStart(2, '0');
            const minutes = parseInt(minute).toString().padStart(2, '0');
            const ampm = parseInt(hour) < 12 ? 'AM' : 'PM';
            this.uuid = slot.uuid,
            this.available = slot.available,
            this.status = slot.status === 'Confirmed' ? 'Confirmed' : 'Active'
            this.time = `${hours}:${minutes} ${ampm}`
            this.localUtcDate = new Date(slot.slot_Date_Utc);
            this.UtcDate = this.getUtcDateOnly(slot.slot_Date_Utc);
            this.Utc_date_time = slot.slot_Date_Utc;
        }
    }
}
export class NewSlotUi{
    slots: SlotUI[] = [];
    date: string;
    day:string;
    dateDay:number;
}